export const RO_LOCALE = 'ro';
export const EN_LOCALE = 'en';
export const BG_LOCALE = 'bg';
export const HU_LOCALE = 'hu';

export const SET_LOCALE = 'SET_LOCALE';
export const setLocale = (locale) => ({
    type: SET_LOCALE,
    payload: locale,
});
